import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import users from './users';
import login from './login';
import clients from './clients';

const rootReducer = combineReducers({
  clients,
  users,
  login,
  routing: routerReducer,
});

export default rootReducer;
